/* Neuer Header (Okt. 2026) – Verhalten zu sections/sd-header.liquid
   · Hochzeit-Menü (Desktop): Klick oder Maus drüber öffnet, Esc/Klick daneben schließt
   · Kopfzeile (Mobil): verschwindet beim Runterscrollen, kommt beim Hochwischen sofort zurück
   · Menü von unten (Mobil): öffnen, schließen per Knopf, Hintergrund, Esc oder nach unten ziehen */
(function () {
  'use strict';

  var MOBIL = window.matchMedia('(max-width: 989px)');
  var header = document.querySelector('[data-sdh]');
  if (!header) return;
  var section = header.closest('.shopify-section') || header.parentNode;

  /* ---------- Hochzeit-Menü (Desktop) ---------- */
  var toggle = header.querySelector('[data-sdh-mega-toggle]');
  var mega = header.querySelector('[data-sdh-mega]');
  var hoverTimer = null;

  function megaOeffnen() {
    if (!mega || !mega.hidden) return;
    mega.hidden = false;
    mega.classList.add('sdh-offen');
    toggle.setAttribute('aria-expanded', 'true');
  }
  function megaSchliessen() {
    if (!mega || mega.hidden) return;
    mega.hidden = true;
    mega.classList.remove('sdh-offen');
    toggle.setAttribute('aria-expanded', 'false');
  }

  if (toggle && mega) {
    toggle.addEventListener('click', function () {
      if (mega.hidden) megaOeffnen(); else megaSchliessen();
    });
    [toggle, mega].forEach(function (el) {
      el.addEventListener('mouseenter', function () {
        if (MOBIL.matches) return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(megaOeffnen, 120);
      });
      el.addEventListener('mouseleave', function () {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(megaSchliessen, 250);
      });
    });
    document.addEventListener('click', function (e) {
      if (!header.contains(e.target)) megaSchliessen();
    });
    header.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !header.contains(e.relatedTarget)) megaSchliessen();
    });
  }

  /* ---------- Kopfzeile beim Scrollen (Mobil) ---------- */
  var letztesY = window.pageYOffset;
  var tickt = false;

  function scrollPruefen() {
    tickt = false;
    var y = window.pageYOffset;
    if (!MOBIL.matches || y < 200) {
      section.classList.remove('sdh-versteckt');
    } else if (y > letztesY + 6) {
      section.classList.add('sdh-versteckt');
    } else if (y < letztesY - 6) {
      section.classList.remove('sdh-versteckt');
    }
    if (Math.abs(y - letztesY) > 6) letztesY = y;
  }
  window.addEventListener('scroll', function () {
    if (!tickt) { tickt = true; window.requestAnimationFrame(scrollPruefen); }
  }, { passive: true });

  /* Mini-Warenkorb oder Live-Suche offen → Kopfzeile nicht wegschieben */
  document.addEventListener('focusin', function (e) {
    if (header.contains(e.target)) section.classList.remove('sdh-versteckt');
  });

  /* ---------- Menü von unten (Mobil) ---------- */
  var sheet = document.querySelector('[data-sdh-sheet]');
  var oeffner = header.querySelector('[data-sdh-sheet-open]');
  if (!sheet || !oeffner) return;
  /* Ans Seitenende hängen: im (klebenden, verschiebbaren) Header-Abschnitt würde "position: fixed" nicht greifen */
  document.body.appendChild(sheet);
  var panel = sheet.querySelector('[data-sdh-sheet-panel]');
  var grip = sheet.querySelector('[data-sdh-sheet-grip]');

  function sheetOeffnen() {
    sheet.classList.remove('sdh-schliesst');
    panel.style.transform = '';
    sheet.hidden = false;
    document.documentElement.classList.add('sdh-gesperrt');
    oeffner.setAttribute('aria-expanded', 'true');
    var erster = sheet.querySelector('.sdh-sheet__close');
    if (erster) erster.focus({ preventScroll: true });
  }
  function sheetSchliessen() {
    if (sheet.hidden) return;
    sheet.classList.add('sdh-schliesst');
    panel.style.transform = '';
    oeffner.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('sdh-gesperrt');
    var fertig = function () {
      sheet.hidden = true;
      sheet.classList.remove('sdh-schliesst');
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) fertig();
    else setTimeout(fertig, 300);
    oeffner.focus({ preventScroll: true });
  }

  oeffner.addEventListener('click', sheetOeffnen);
  Array.prototype.forEach.call(sheet.querySelectorAll('[data-sdh-sheet-close]'), function (el) {
    el.addEventListener('click', sheetSchliessen);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    sheetSchliessen();
    megaSchliessen();
  });
  MOBIL.addEventListener && MOBIL.addEventListener('change', function (e) {
    if (!e.matches) sheetSchliessen(); else megaSchliessen();
  });

  /* Nach unten ziehen zum Schließen (am Griff) */
  var startY = null, dy = 0;
  grip.addEventListener('touchstart', function (e) {
    startY = e.touches[0].clientY; dy = 0;
    sheet.classList.add('sdh-zieht');
  }, { passive: true });
  grip.addEventListener('touchmove', function (e) {
    if (startY === null) return;
    dy = Math.max(0, e.touches[0].clientY - startY);
    panel.style.transform = 'translateY(' + dy + 'px)';
  }, { passive: true });
  grip.addEventListener('touchend', function () {
    sheet.classList.remove('sdh-zieht');
    if (dy > 90) sheetSchliessen();
    else panel.style.transform = '';
    startY = null;
  });
})();
